// excluded from code coverage

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

Vue.config.productionTip = false;

const aiKey = process.env.VUE_APP_APPLICATION_INSIGHTS_KEY;

if ( aiKey ) {
  const appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: aiKey,
      disableAjaxTracking: true,
    },
  });
  appInsights.loadAppInsights();
  appInsights.trackPageView();
}

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
